// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sandwich"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14.2788 3.3934C14.6979 3.16478 15.2202 3.26433 15.5259 3.6311L20 8.99999V21H4V8.99999L14.2788 3.3934Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M20 9V15H4V9H20Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 15H20M4.75 9.00003H19.25M20 9.36208V21H4V9.00003L14.2788 3.3934C14.698 3.16478 15.2203 3.26433 15.5259 3.63111L19.7682 8.7219C19.918 8.90161 20 9.12815 20 9.36208Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SandwichIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sandwich',
    ref,
    icon: element,
  },
));

SandwichIcon.displayName = 'SandwichIcon';

export default SandwichIcon;
